module.exports = __webpack_public_path__ + "img/success.0b9c2050.svg";